var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUpRightLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16647 15.2083C4.32481 15.2083 4.48314 15.15 4.60814 15.025L16.2748 3.35828C16.5165 3.11662 16.5165 2.71662 16.2748 2.47495C16.0331 2.23328 15.6331 2.23328 15.3915 2.47495L3.72481 14.1416C3.48314 14.3833 3.48314 14.7833 3.72481 15.025C3.84981 15.15 4.00814 15.2083 4.16647 15.2083Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.833 12.1001C16.1747 12.1001 16.458 11.8167 16.458 11.4751V2.91675C16.458 2.57508 16.1747 2.29175 15.833 2.29175H7.27467C6.93301 2.29175 6.64967 2.57508 6.64967 2.91675C6.64967 3.25841 6.93301 3.54175 7.27467 3.54175H15.208V11.4751C15.208 11.8167 15.4913 12.1001 15.833 12.1001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpRightLight);
export default __webpack_public_path__ + "static/media/arrow_up_right_light.b5dc5e3cbbd89f4027207151c4960069.svg";
export { ForwardRef as ReactComponent };